import { render, staticRenderFns } from "./ChatbotWidget.vue?vue&type=template&id=3eff37b4&"
import script from "./ChatbotWidget.vue?vue&type=script&lang=js&"
export * from "./ChatbotWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotWidget.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports